import styled from 'styled-components';

export const FilterStyled = styled.div`
  display: grid;
  grid-row-gap: 16px;
  grid-column-gap: 16px;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto auto;
  grid-auto-rows: auto;

  & > :first-child {
    grid-column: span 2;
  }

  .controls {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .control-action {
      display: flex;
      flex-grow: 1;
      justify-content: end;
    }
  }
`;
